// extracted by mini-css-extract-plugin
module.exports = {"item":"partner-logos_item__p5ot7","list":"partner-logos_list__gP06a"};